import {PromocodeProviderEnum} from "../../../"

export class ValidatePromocodeRequest {
    promocode: string
    promocodeProvider: PromocodeProviderEnum
    formData: {[key: string]: any}
    constructor(
        promocode: string,
        promocodeProvider: PromocodeProviderEnum,
        formData: {[key: string]: any}
    ) {
        this.promocode = promocode
        this.promocodeProvider = promocodeProvider
        this.formData = formData
    }
}